import React from 'react';

// The multi-line counterpart of ui/Input, in the same redesign shape:
// borderless on the paper card, 16px so iOS doesn't zoom on focus.
const Textarea = React.forwardRef(({
  className = '',
  rows = 5,
  disabled = false,
  ...props
}, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    disabled={disabled}
    className={`flex w-full rounded-lg border-0 bg-white px-4 py-3 text-[16px] placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
    {...props}
  />
));

Textarea.displayName = 'Textarea';

export default Textarea;
